<template>
  <div :id="'cont'+id" class="cont" data-pct="0">
    <svg class="svg-cp" width="200" height="200" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <circle r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
      <circle :id="'bar-cp'+id" class="bar-cp" r="90" cx="100" cy="100" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
    </svg>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        id: 1,
        value: 20
      }
    },
    props: ['identifier', 'percent'],
    methods: {
      setData () {
        let circle = document.getElementById('bar-cp' + this.id)
        // console.log(circle)
        let cont = document.getElementById('cont' + this.id)

        let color = ''
        // ganti warna
        if (this.value === 0) {
          color = '#9E9E9E'
        } else if (this.value <= 40) {
          color = '#FF6969'
        } else if (this.value <= 80) {
          color = '#FFA400'
        } else if (this.value < 100) {
          color = '#5374FA'
        } else if (this.value === 100) {
          color = '#0CCE6B'
        }
        circle.style.stroke = color
        cont.style.background = color + '44' // transparentcy
        cont.style.color = color
        //
        let r = circle.getAttribute('r')
        let c = 3.14 * (r * 2)
        //
        let pct = ((100 - this.value) / 100) * c
        circle.style.strokeDashoffset = pct

        cont.setAttribute('data-pct', this.value)
      }
    },
    mounted () { // pelajari mounted dan created!
      // created dijalankan duluan dari pada mounted
      // pas mounted itu, html nya udah di render, jadi kalau ada variable, setnya di created dulu.
      setTimeout(() => {
        this.setData()
      })
    },
    created () {
      this.id = this.$props.identifier
      this.value = this.$props.percent
      if (this.value > 100) {
        this.value = 100
      }
    }
  }
</script>

<style>
  .svg-cp circle {
    stroke-dashoffset: 565.48;
    transition: stroke-dashoffset 1s linear;
    /*stroke: #666;*/
    stroke-width: 1em;
  }
  .svg-cp .bar-cp {
    stroke: #9E9E9E;
  }
  .cont {
    transform: rotate(270deg);
    background: #9E9E9E44;
    display: block;
    height: 200px;
    width: 200px;
    margin: 2em auto;
    box-shadow: 0 0 1em black;
    border-radius: 100%;
    position: relative;
    transition: all 1s linear
  }
  .cont:after {
    text-align: center;
    position: absolute;
    display: block;
    height: 160px;
    width: 160px;
    left: 50%;
    top: 50%;
    /*box-shadow: inset 0 0 1em black;*/
    content: attr(data-pct);
    margin-top: -80px;
    margin-left: -80px;
    border-radius: 100%;
    line-height: 160px;
    font-size: 4em;
    font-family: 'Courier';
    font-weight: bold;
    transform: rotate(90deg);
    /*text-shadow: 0 0 0.5em black;*/
  }
</style>